<script lang="ts">
    import TemplateSettingsGeneral from './TemplateSettingsGeneral.svelte';
    import { _, locales } from 'svelte-i18n';
    import { clientSettings, customerSettings } from '../../../stores/api';
    import SettingsRowNumber from './SettingsRowNumber.svelte';
    import { z } from 'zod';
    import SelectHour from '../../shared/SelectHour.svelte';
    import SettingsRow from './SettingsRow.svelte';
    import SettingsRowLabel from './SettingsRowLabel.svelte';
    import SettingsRowValue from './SettingsRowValue.svelte';
    import { langs } from '../../../locale/langs';
    import Checkbox from '../../shared/Checkbox/Checkbox.svelte';
    import Separator from '../../shared/Separator.svelte';
    import { debug } from '../../../stores/store';
    // import Select from "svelte-select";
    import Select from '../../shared/Select.svelte';
    import NewColumnSelectListItem from '../../shared/ColumnSelectPro/NewColumnSelectListItem.svelte';
    import ColorSymbol from '../../shared/ColorSymbol.svelte';

    export let updateClient: () => void;

    // see JobsOnMap.js to implement some logic
    const iconStyles = [
        { id: 'bold', label: $_('Solid') },
        { id: 'outline', label: $_('Outline') },
        { id: 'classic', label: $_('Classic') },
    ];

    // let selectedId = 'bold';
</script>

<TemplateSettingsGeneral>
    <div slot="label">{$_('Display')}</div>
    <div slot="content">
        {#if $debug}
            {JSON.stringify($clientSettings.display)}
        {/if}
        <SettingsRow>
            <SettingsRowLabel>
                {$_('Map icon style')}
            </SettingsRowLabel>
            <SettingsRowValue>
                <div class="map-style-icon-all">
                    {#each iconStyles as style}
                        <div
                            title={style.label}
                            class="map-style-icon-one"
                            class:map-style-icon-one-active={$clientSettings.display.icon_style ===
                                style.id}
                            on:click={() => {
                                $clientSettings.display.icon_style = style.id;
                                updateClient();
                            }}
                        >
                            <ColorSymbol color="#70a0ff" iconStyle={style.id} scale={0.6} />
                        </div>
                    {/each}
                </div>
            </SettingsRowValue>
        </SettingsRow>
        <SettingsRow>
            <SettingsRowLabel>
                {$_('Show relative dates')}
            </SettingsRowLabel>
            <SettingsRowValue>
                <Checkbox
                    bind:checked={$clientSettings.display.showRelativeToday}
                    label=""
                    onChange={s => {
                        updateClient();
                        return true;
                    }}
                />
            </SettingsRowValue>
        </SettingsRow>
    </div>
</TemplateSettingsGeneral>

<style>
    .map-style-icon-all {
        display: flex;
        flex-direction: row;
        column-gap: 10px;
    }
    .map-style-icon-one {
        /*margin-right: 10px;*/
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 7px;
    }
    .map-style-icon-one:hover {
        cursor: pointer;
        border: 1px solid #7d8fac;
    }
    .map-style-icon-one-active {
        background-color: #e1eafc;
        border: 1px solid #7d8fac;
    }

    :root {
        --font-size: 15px;
        --chevron-width: 20px;
        --chevron-height: 20px;
    }
    :global(.svelte-select) {
        border-radius: 0 !important;
        border: 1px solid transparent !important;
        border-bottom: 1px solid #bababa !important;
        min-height: 30px !important;
        padding: 0 0 0 5px !important;
    }
    .selected-item {
        font-weight: 500;
    }
    :global(.list-item .item) {
        padding: 0 !important;
    }
    :global(.value-container) {
        padding: 0 !important;
    }

    .customItem {
        display: flex;
        flex-direction: row;
        /*font-size: 12px;*/
        column-gap: 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        align-items: center;
        font-family: 'roboto' !important;
        font-size: 15px;
    }
    .customItem_examples {
        display: flex;
        flex-direction: row;
        opacity: 0.7;
        font-size: 12px;
    }
</style>
